<template>
    <div class="row left-content">
        <div class="col-12">
            <h1>Attach bank data to get payments</h1>
        </div>
        <div class="col-5">
            <div class="white-block">
                <div class="container">
                    <b-form>
                        <div class="row">
                            <div class="col-12">
                                <b-form-input
                                    v-model="form.routingNumber"
                                    type="text"
                                    placeholder="Routing Number"
                                    class="mb-2"
                                ></b-form-input>
                            </div>
                            <div class="col-12">
                                <b-form-input
                                    v-model="form.accountNumber"
                                    type="text"
                                    placeholder="Account Number"
                                    class="mb-2"
                                ></b-form-input>
                            </div>
                        </div>
                        <b-button variant="primary" type="submit" @click.prevent.stop="create()">Attach</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="(error, index) in errors" :key="error">{{ index + ': ' + error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
export default {
    name: "Transfer",
    mixins: [ServerErrors],
    data() {
        return {
            errors: [],
            form: {
                routingNumber: null,
                accountNumber: null
            }
        }
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            this.errors = [];
            window.axios({
                method: 'POST',
                url: '/admin/wallet/project/customer/set-transfer-data',
                data: this.form
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.view' });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    }
}
</script>